export default "__VITE_ASSET__96e9ae88__"